var map = {
	"./art.svg": "RE3s",
	"./business.svg": "V1O6",
	"./certificate.svg": "g6cP",
	"./computer_science.svg": "jngS",
	"./design.svg": "V9fC",
	"./duration.svg": "vpIl",
	"./effort.svg": "h1l0",
	"./engineering.svg": "hyu1",
	"./health_and_medical_science.svg": "479E",
	"./humanities.svg": "3cN9",
	"./language.svg": "nUBa",
	"./length.svg": "dQUn",
	"./level.svg": "Cm0B",
	"./life_science.svg": "gcsk",
	"./mathematics.svg": "8eVP",
	"./next_start_date.svg": "a0+j",
	"./personal_development_and_professional_studies.svg": "iEeP",
	"./physical_science.svg": "b64U",
	"./platform.svg": "pTqN",
	"./provider.svg": "UVUD",
	"./quiz.svg": "mFDB",
	"./reading.svg": "6b9g",
	"./social_science.svg": "gW/C",
	"./subtitle.svg": "Rvww",
	"./video.svg": "R37Z",
	"./website.svg": "ZJ46"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jWmk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/atom/icon/light ^\.\/.*\.svg$
// module id = jWmk
// module chunks = 11